import {Directive, ElementRef, HostListener, Input} from '@angular/core';

@Directive({
    selector: '[toggleClassOnClick]',
    standalone: false
})
export class ToggleClassOnClickDirective {
    @Input('toggleClassOnClick') classes: string = "";
    @Input('toggleClassOnClickIf') enabled: boolean = true;
    @Input('toggleClassOnClickRemoveOnOut') removeOnOut: boolean = false;

    constructor(private el: ElementRef) {}

    @HostListener('click')
    onClick() {
        if (!this.enabled) return;

        let classes = this.classes.split(" ");
        let el = this.el.nativeElement;

        for (var i = 0; i < classes.length; i++) {
            el.classList.toggle(classes[i]);
        }
    }

    @HostListener('mouseleave')
    onMouseLeave() {
        if (!this.enabled) return;
        if (!this.removeOnOut) return;

        let classes = this.classes.split(" ");
        let el = this.el.nativeElement;

        for (var i = 0; i < classes.length; i++) {
            el.classList.remove(classes[i]);
        }
    }
}
